import axios from 'axios';
import getTokenFromCookies from "@/helpers/getTokenFromCookies";
const PlantLibraryService = {};

PlantLibraryService.getAllPlants = function (params) {
    const headers = {
        Authorization: `Bearer ${getTokenFromCookies()}`,
    };

    return axios.get(`${axios.defaults.baseURL}/api/v1/plant-library/plants`, {
        params,
        headers,
    });
};

PlantLibraryService.getPlantById = function (id, params) {
    const headers = {
        Authorization: `Bearer ${getTokenFromCookies()}`,
    };

    return axios.get(
        `${axios.defaults.baseURL}/api/v1/plant-library/plants/${id}`,
        {
            params,
            headers,
        },
    );
};

PlantLibraryService.addPlantToFavorites = function (id) {
    const headers = {
        Authorization: `Bearer ${getTokenFromCookies()}`,
    };

    const { data } = axios.post(
        `${axios.defaults.baseURL}/api/v1/plant-library/favorites/${id}`,
        {},
        { headers }

    );
    return data;
};

PlantLibraryService.deletePlantFromFavorites = async function (id) {
    const headers = {
        Authorization: `Bearer ${getTokenFromCookies()}`,
    };
    const { data } = await axios.delete(
        `${axios.defaults.baseURL}/api/v1/plant-library/favorites/${id}`,
        { headers }
    );
    return data;
};
export default PlantLibraryService;
